import classNames from 'classnames';
import styles from './index.module.sass';
import { Spin } from 'antd';
import { notification } from 'antd';
import { BuyerItem } from '@@/seller-account/components/sidebar/components/buyer-item';
import md5 from 'md5';
import {
  $buyersDataLoading,
  $localDisabledBuyers,
  fetchBuyerByIdFx,
  fetchBuyersListFx,
  updateBuyerFx,
} from '@/modules/seller-account/store/buyers.store';
import { PartnersNotifier } from '../partners-notifier';
import { useStore } from 'effector-react';
import { Notifier } from '../../../../../common/components/notifier';

export const BuyersList = ({
  data,
  activeItem,
  buyerUpdateLoading,
  setBuyerUpdateLoading,
  onClick,
  orderBy,
  sortOption,
  searchString,
  setShowBuyerModal,
}: IArgs) => {
  const dataLoading = useStore($buyersDataLoading);
  const localeDisabledBuyers = useStore($localDisabledBuyers);
  return (
    <div className={styles.root}>
      <ul className={styles.buyerItems}>
        <Spin
          className={classNames(
            styles.spin,
            !dataLoading.loading && styles.spinDisabled,
          )}
          size="large"
        />
        <li>
          <PartnersNotifier />
        </li>
        <li>
          <Notifier
            bgColor="rgb(64, 155, 255)"
            textColor="#fff"
            heading="Добавление Ваших агентов"
            text="Вы можете добавить агентов и их предложения в систему, в случае, если уже работаете со своими партнерами"
            buttonLabel="добавить нового покупателя"
            onClick={() => {
              setShowBuyerModal(true);
            }}
          />
        </li>
        {data ? (
          Array.isArray(data) &&
          data?.map((item, i) => (
            <BuyerItem
              key={i}
              checked={
                //localeDisabledBuyers.includes(item.id) ? false : 
                item.checked
              }
              activeTrades={item.trades_count}
              active={activeItem === item.id}
              onClick={() => onClick(item, i)}
              onSwitchChange={async (val: boolean) => {
                setBuyerUpdateLoading({ loading: true, id: i });
                const res = await updateBuyerFx({
                  id: item.id,
                  data: { enabled: val },
                  md5: item.type === 'external' ? md5(item.label) : undefined,
                });
                if ('error' in res || 'errors' in res) {
                  setBuyerUpdateLoading({ loading: false, id: -1 });
                  return notification.error({
                    message:
                      res.error ||
                      `При ${
                        val ? 'активации' : 'деактивации'
                      } контрагента возникла непредвиденная ошибка`,
                  });
                }
                await fetchBuyersListFx({
                  sortBy: sortOption.find((item) => item.active)?.val,
                  orderBy,
                  search: searchString,
                });
                setBuyerUpdateLoading({ loading: false, id: -1 });
                onClick(item, i);
                // await fetchBuyerByIdFx({
                //   id: item.id,
                //   md5: item.type === 'external' ? md5(item.label) : undefined,
                // });
              }}
              loading={buyerUpdateLoading.loading && i === buyerUpdateLoading.id}
              label={item.label}
              type={item.type as 'internal' | 'external'}
              distance={item.distance.toFixed(1)}
            />
          ))
        ) : (
          <span className={styles.placeHolder}>
            покупатели еще не добавлены в систему
          </span>
        )}
      </ul>
    </div>
  );
};

type updLoading = {
  loading: boolean;
  id: number;
};

interface IArgs {
  buyersData: any;
  data: any;
  setActiveBuyer: (val: number) => void;
  activeItem: number;
  buyerUpdateLoading: updLoading;
  setBuyerUpdateLoading: (val: updLoading) => void;
  onClick: (item: { type: string; id: number; label: string }, i: number) => void;
  orderBy: 'asc' | 'desc';
  sortOption: { label: string; val: string; active: boolean }[];
  searchString: string;
  setSearchString: (val: string) => void;
  setShowBuyerModal: (val: boolean) => void;
}
